(() => {
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const decode = value => { const el = document.createElement('textarea'); el.innerHTML = value; return el.value; };
  function init(scope = document) {
    scope.querySelectorAll('[data-logo-banner]').forEach(banner => {
      if (banner.dataset.ready) return;
      banner.dataset.ready = 'true';
      banner.querySelector('[data-logo-pause]').addEventListener('click', event => {
        const paused = banner.classList.toggle('is-paused');
        event.currentTarget.setAttribute('aria-pressed', String(paused));
        event.currentTarget.setAttribute('aria-label', paused ? 'Play logo animation' : 'Pause logo animation');
        event.currentTarget.textContent = paused ? '▶' : 'Ⅱ';
      });
    });
    scope.querySelectorAll('[data-refresh-finder]').forEach(quiz => {
      if (quiz.dataset.ready) return;
      quiz.dataset.ready = 'true';
      const dialog = quiz.querySelector('dialog');
      const labels = JSON.parse(quiz.querySelector('[data-finder-labels]').textContent);
      const data = JSON.parse(quiz.querySelector('[data-finder-data]').textContent).map(p => Object.fromEntries(Object.entries(p).map(([k,v]) => [k, typeof v === 'string' ? decode(v) : v])));
      const form = quiz.querySelector('[data-finder-form]');
      const results = quiz.querySelector('[data-finder-results]');
      const cards = quiz.querySelector('[data-finder-cards]');
      const progress = quiz.querySelector('[data-finder-progress]');
      const status = quiz.querySelector('[data-finder-status]');
      const compare = quiz.querySelector('[data-finder-compare]');
      const comparison = quiz.querySelector('[data-comparison]');
      const other = quiz.querySelector('[data-finder-other]');
      const selected = new Set();
      let step = 0, answers = {}, returnFocus;
      const money = amount => amount === null ? escape(labels.tbc) : `<span class="picky-money"><img class="picky-dirham" src="${escape(labels.dirham)}" alt="AED" width="22" height="22"><span>${new Intl.NumberFormat('en-AE',{minimumFractionDigits:2,maximumFractionDigits:2}).format(amount)}</span></span>`;
      const responseLabel = p => labels[p.style.replace('-','_')] || labels.not_rated;
      const updateSelection = () => {
        compare.disabled = selected.size < 2;
        quiz.querySelector('[data-selection-status]').textContent = `${selected.size} / 3 · ${labels.selected}`;
        comparison.hidden = true;
      };
      const go = n => {
        step = n; form.hidden = n === 2; results.hidden = n !== 2;
        quiz.querySelectorAll('[data-finder-step]').forEach(el => {el.hidden = Number(el.dataset.finderStep) !== n;});
        quiz.querySelector('[data-finder-back]').hidden = n === 0;
        quiz.querySelector('[data-finder-error]').hidden = true;
        progress.textContent = `${labels.step} ${n + 1} / 3 · ${[labels.style,labels.budget,labels.matches][n]}`;
        dialog.scrollTo({top:0,behavior:'instant'});
        if (n < 2) quiz.querySelector(`[data-finder-step="${n}"] input`)?.focus();
      };
      const draw = () => {
        const budget = answers.budget === 'any' ? Infinity : Number(answers.budget);
        const exact = data.filter(p => (p.price === null ? budget === Infinity : p.price <= budget) && p.style === answers.style);
        const visible = data.filter(p => (p.price === null ? budget === Infinity : p.price <= budget) && (p.style === answers.style || other.checked)).sort((a,b) => (b.style === answers.style) - (a.style === answers.style) || (a.price ?? Infinity)-(b.price ?? Infinity));
        const visibleIds = new Set(visible.map(p => p.id));
        [...selected].forEach(id => {if(!visibleIds.has(id)) selected.delete(id);});
        status.textContent = exact.length ? '' : labels.no_match;
        cards.innerHTML = visible.map(p => `<article class="refresh-match"><a class="refresh-match__image" href="${escape(p.url)}">${p.image ? `<img src="${escape(p.image)}" alt="${escape(p.brand+' '+p.model)}" width="180" height="180" loading="lazy">` : `<strong>${escape(p.brand)}</strong>`}</a><div class="refresh-match__info"><small>${escape(p.brand)}</small><h4><a href="${escape(p.url)}">${escape(p.model)}</a></h4><p class="refresh-match__setup">${escape(p.setup)}${p.variant && /handle/i.test(p.variant) ? `<br>${escape(p.handle)} handle` : ''}</p><strong>${money(p.price)}</strong><p class="picky-stock-label">${escape(p.available ? 'In stock' : labels.stock)}</p><p class="refresh-match__reason">${escape(p.reason || labels.not_rated)}</p><label><input type="checkbox" data-compare-id="${p.id}" ${selected.has(p.id)?'checked':''}> ${escape(labels.comparison)}</label></div></article>`).join('');
        updateSelection();
      };
      quiz.querySelector('[data-finder-open]').addEventListener('click', () => {returnFocus = document.activeElement;dialog.showModal();go(0);});
      quiz.querySelector('[data-finder-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => returnFocus?.focus());
      dialog.addEventListener('click', e => {if(e.target === dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (!quiz.querySelector(`[data-finder-step="${step}"] input:checked`)) {quiz.querySelector('[data-finder-error]').hidden=false;return;}
        if(step===0)go(1); else {answers=Object.fromEntries(new FormData(form));selected.clear();other.checked=false;draw();go(2);}
      });
      quiz.querySelector('[data-finder-back]').addEventListener('click',()=>go(0));
      quiz.querySelector('[data-finder-retake]').addEventListener('click',()=>{form.reset();selected.clear();go(0);});
      other.addEventListener('change',draw);
      cards.addEventListener('change', event => {
        const input = event.target.closest('[data-compare-id]');if(!input)return;
        const id=data.find(p=>String(p.id) === input.dataset.compareId)?.id;
        if(input.checked && selected.size>=3){input.checked=false;status.textContent=labels.compare_limit;return;}
        input.checked?selected.add(id):selected.delete(id);status.textContent=labels.compare_hint;updateSelection();
      });
      compare.addEventListener('click',()=>{
        const paddles=data.filter(p=>selected.has(p.id));if(paddles.length<2)return;
        const rows=[['price',p=>money(p.price)],['availability',p=>escape(p.available?'In stock':labels.stock)],['color',p=>escape(p.color||labels.unknown)],['thickness',p=>escape(p.thickness||labels.unknown)],['shape',p=>escape(p.shape||labels.unknown)],['profile',p=>escape(responseLabel(p))],...['weight','core','face','handle','swing','twist'].map(key=>[key,p=>escape(p[key]||labels.unknown)]),['reason',p=>escape(p.reason||labels.not_rated)]];
        comparison.innerHTML=`<h3>${escape(labels.comparison)}</h3><div class="refresh-compare-scroll"><table><thead><tr><th scope="col">${escape(labels.name)}</th>${paddles.map(p=>`<th scope="col"><a href="${escape(p.url)}">${escape(p.brand+' '+p.model)}</a><p>${escape(p.setup)}</p></th>`).join('')}</tr></thead><tbody>${rows.map(([key,render])=>`<tr><th scope="row">${escape(labels[key])}</th>${paddles.map(p=>`<td>${render(p)}</td>`).join('')}</tr>`).join('')}</tbody></table></div>`;
        comparison.hidden=false;comparison.focus();comparison.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
      });
    });
  }
  document.addEventListener('click', e => {document.querySelectorAll('.refresh-mega[open]').forEach(menu=>{if(!menu.contains(e.target))menu.open=false;});});
  document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.refresh-mega[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});
  document.addEventListener('shopify:section:load',e=>init(e.target));
  init();
})();

(() => {
  const hoverPointer = matchMedia('(hover: hover) and (pointer: fine)');
  const bindMenus = (scope = document) => {
    scope.querySelectorAll('.refresh-mega').forEach(menu => {
      if (menu.dataset.hoverBound) return;
      menu.dataset.hoverBound = 'true';
      let closeTimer;
      menu.addEventListener('pointerenter', event => {
        if (!hoverPointer.matches || event.pointerType !== 'mouse') return;
        clearTimeout(closeTimer);
        menu.open = true;
      });
      menu.addEventListener('pointerleave', event => {
        if (!hoverPointer.matches || event.pointerType !== 'mouse') return;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => { if (!menu.matches(':focus-within')) menu.open = false; }, 180);
      });
      menu.addEventListener('focusout', () => {
        setTimeout(() => { if (!menu.matches(':focus-within') && !menu.matches(':hover')) menu.open = false; }, 0);
      });
    });
  };
  bindMenus();
  document.addEventListener('shopify:section:load', event => bindMenus(event.target));
})();
